var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 36,
    viewBox: "0 0 33 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1014_1095)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2312 19.6909C10.7955 18.5794 11.6566 17.6459 12.7189 16.9938C13.7813 16.3418 15.0035 15.9966 16.25 15.9966C17.4965 15.9966 18.7187 16.3418 19.7811 16.9938C20.8434 17.6459 21.7045 18.5794 22.2687 19.6909",
    fill: "#FBFAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.25 23C21.7728 23 26.25 18.5228 26.25 13C26.25 7.47715 21.7728 3 16.25 3C10.7272 3 6.25 7.47715 6.25 13C6.25 18.5228 10.7272 23 16.25 23Z",
    fill: "#263322",
    stroke: "#263322",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.311 28.5671C19.7813 28.5671 22.5945 25.7538 22.5945 22.2835C22.5945 18.8132 19.7813 16 16.311 16C12.8407 16 10.0274 18.8132 10.0274 22.2835C10.0274 25.7538 12.8407 28.5671 16.311 28.5671Z",
    fill: "#FBFAF2",
    stroke: "#FBFAF2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.311 18C19.0724 18 21.311 15.7614 21.311 13C21.311 10.2386 19.0724 8 16.311 8C13.5495 8 11.311 10.2386 11.311 13C11.311 15.7614 13.5495 18 16.311 18Z",
    fill: "#FBFAF2",
    stroke: "#263322",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 2,
    rx: 1,
    transform: "matrix(1 0 0 -1 12.25 35)",
    fill: "#263322"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1014_1095"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(4.25 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountSelected);
export default __webpack_public_path__ + "static/media/AccountSelected.002234c250029250db0f9596aac28ef2.svg";
export { ForwardRef as ReactComponent };